var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "time_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.81a8.182 8.182 0 100 16.364A8.182 8.182 0 0012 4.81zM2 12.992c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.617a1 1 0 011 1v4.444l2.447 1.224a1 1 0 11-.894 1.789l-3-1.5a1 1 0 01-.553-.895V8.617a1 1 0 011-1z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDQuODFhOC4xODIgOC4xODIgMCAxMDAgMTYuMzY0QTguMTgyIDguMTgyIDAgMDAxMiA0Ljgxek0yIDEyLjk5MmMwLTUuNTIzIDQuNDc3LTEwIDEwLTEwczEwIDQuNDc3IDEwIDEwLTQuNDc3IDEwLTEwIDEwLTEwLTQuNDc3LTEwLTEweiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA3LjYxN2ExIDEgMCAwMTEgMXY0LjQ0NGwyLjQ0NyAxLjIyNGExIDEgMCAxMS0uODk0IDEuNzg5bC0zLTEuNWExIDEgMCAwMS0uNTUzLS44OTVWOC42MTdhMSAxIDAgMDExLTF6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
export { SvgTime as ReactComponent };